module.exports = __webpack_public_path__ + "img/group-of-risk.3dc0a745.svg";